@if (hasPermission()) {
    <button
        type="button"
        id="rotateToolBtn"
        class="btn btn-default nlr-icon-btn"
        [title]="getTooltip()"
        [ngClass]="{active: isActive(), 'nlrp-suspended': isSuspended()}"
        (click)="toggle()"
        [disabled]="isDisabled()">
        <i class="nlrp-icon nlrp-icon-rotate-annotation"></i>
    </button>
}
